[
  {
    "code": "BT-33",
    "name": "Bumthang"
  },
  {
    "code": "BT-12",
    "name": "Chhukha"
  },
  {
    "code": "BT-22",
    "name": "Dagana"
  },
  {
    "code": "BT-GA",
    "name": "Gasa"
  },
  {
    "code": "BT-13",
    "name": "Ha"
  },
  {
    "code": "BT-44",
    "name": "Lhuentse"
  },
  {
    "code": "BT-42",
    "name": "Monggar"
  },
  {
    "code": "BT-11",
    "name": "Paro"
  },
  {
    "code": "BT-43",
    "name": "Pemagatshel"
  },
  {
    "code": "BT-23",
    "name": "Punakha"
  },
  {
    "code": "BT-45",
    "name": "Samdrup Jongkha"
  },
  {
    "code": "BT-14",
    "name": "Samtse"
  },
  {
    "code": "BT-31",
    "name": "Sarpang"
  },
  {
    "code": "BT-15",
    "name": "Thimphu"
  },
  {
    "code": "BT-TY",
    "name": "Trashi Yangtse"
  },
  {
    "code": "BT-41",
    "name": "Trashigang"
  },
  {
    "code": "BT-32",
    "name": "Trongsa"
  },
  {
    "code": "BT-21",
    "name": "Tsirang"
  },
  {
    "code": "BT-24",
    "name": "Wangdue Phodrang"
  },
  {
    "code": "BT-34",
    "name": "Zhemgang"
  }
]